import axios from 'axios';
import { WIDGET_SECRET,SERVER_BASE_URL } from '../constants.js';

const axiosInstance = axios.create({
    baseURL: `${SERVER_BASE_URL}`,
    headers: { authorization: WIDGET_SECRET}
});

export default axiosInstance;